import React from "react";

const HomeIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.875 9.00006L8.33667 1.53756C8.70333 1.17173 9.29667 1.17173 9.6625 1.53756L17.125 9.00006M2.75 7.12506V15.5626C2.75 16.0801 3.17 16.5001 3.6875 16.5001H7.125V12.4376C7.125 11.9201 7.545 11.5001 8.0625 11.5001H9.9375C10.455 11.5001 10.875 11.9201 10.875 12.4376V16.5001H14.3125C14.83 16.5001 15.25 16.0801 15.25 15.5626V7.12506M5.875 16.5001H12.75" stroke="#5C91FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>   
  );
};

export default HomeIcon;
